'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceLogger = enforceLogger;

var _BaseEventLogger = require('event-tracking-tools/loggers/BaseEventLogger');

var _BaseEventLogger2 = _interopRequireDefault(_BaseEventLogger);

var _utils = require('react-utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enforceLogger(logger) {
  (0, _utils.invariant)(logger instanceof _BaseEventLogger2.default, 'connectLogger: param loggerClass must be a class that extends from BaseEventLogger. Got "%s"', logger);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/events/validateConnectLogger.js
// module id = 537
// module chunks = 0